import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  message,
  Select,
  Empty,
  Typography,
  Icon,
} from "antd";
import { EyeFilled, EditFilled, WhatsAppOutlined } from "@ant-design/icons";
import { ContextAPI } from "../../../ContextAPI";
import { platformApi } from "../../../api";
import WrappedMessageInterface from "./MessageInterface";
import WrappedCallingInterface from "./CallingInterface";
import WrappedWhatsAppInterface from "./WhatsAppInterface";
import AttachQuotation from "./AttachQuotation";
import QuotationModal from "../../TransactionMasters/Quotations/QuotationsForm";
import WrappedAddActivityModal from "./AddActivityModal";
import BookingRegisterModal from "../../TransactionMasters/BookingRegister/BookingRegisterModal";
import "./style.less";
import moment from "moment";
import { custom } from "@hapi/joi";
import VehicleName from "../../VehicleName";

const QuotationInfo = (props) => {
  const {
    dataSource,
    getCustomerInfo,
    getActivityByCustomer,
    linkQuotation,
    customerDetail,
    createQuotation,
    customerId,
  } = props;
  const { Text, Title } = Typography;
  const [callModal, setCallModal] = useState(false);
  const [quotationModal, setQuotationModal] = useState(false);
  const [quotationDetail, setQuotationDetail] = useState(null);
  const [quotationEditable, setQuotationEditable] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [whatsAppMessageModal, setWhatsAppMessageModal] = useState(false);
  const [activityModal, setActivityModal] = useState(false);
  const [attachQuotationModal, setAttachQuotationModal] = useState(false);
  const [bookingId, setBookingId] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [bookingType, setBookingType] = useState("ConfirmBooking");
  const [bookingModal, setBookingModal] = useState(false);
  const { loginCredintials } = useContext(ContextAPI);
  const [view, setView] = useState(false);
  const [moduleid, setModuleid] = useState(null);

  const location = useLocation();

  useEffect(() => {
    fetchModuleId();
  }, [location])

  const fetchModuleId = () => {
    const id = extractModule(location.pathname);
    setModuleid(id);
  }

  const extractModule = (url) => {
    const parts = url?.split('/');

    const phoneNumber = parts[parts.length - 1];
    return phoneNumber;
  }


  const column = [
    {
      title: <Text strong>Quotation No</Text>,
      dataIndex: "quotationId",
      key: "quotationId",
      width: 130,
      render: (record) => (
        <span style={{ whiteSpace: "nowrap" }}>{record}</span>
      ),
    },
    {
      title: <Text strong>Vehicle</Text>,
      dataIndex: "vehicle",
      key: "vehicle",
      width: 200,
      render: (record) =>
        record && record.length ? (
          <VehicleName
            nameOnly
            value={record[0].vehicleDetail}
            fallback="-"
          />
        ) : (
          <span>-</span>
        ),
    },
    {
      title: <Text strong>Created On</Text>,
      dataIndex: "createdAt",
      key: "createdAt",
      width: 95,
      render: (record) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(new Date(record)).format("DD/MM/YYYY")}
        </span>
      ),
    },
    {
      title: <Text strong>Action</Text>,
      dataIndex: "id",
      align: "center",
      key: "id",
      width: 75,
      render: (record) => (
        <EyeFilled
          style={{ textAlign: "center" }}
          onClick={() => viewQuotation(record)}
        />
      ),
    },
  ];
  const viewQuotation = (quotationId) => {
    getQuotation(quotationId);
    setQuotationModal(true);
    setView(true);
  };

  const getQuotation = (quotationId) => {
    return new Promise(async (resolve, reject) => {
      await platformApi.get(`/api/quotation/${quotationId}`).then((res) => {
        const {
          data: {
            response: { data },
          },
        } = res;
        setQuotationDetail(data);
        resolve(data);
      });
    });
  };

  useEffect(() => {
    if (!customerId) {
      console.log("No customerId provided");
      return;
    }

    console.log("Fetching customer with ID:", customerId);

    platformApi.get("/api/customer/" + customerId)
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          const { response } = data;
          if (response.code === 200) {
            console.log("Customer fetched successfully:", {
              dbId: response.data.id,
              displayId: response.data.customerId
            });

            // Create customer object with both IDs
            let customerData = {
              customer: {
                ...response.data,
                id: response.data.id,                 // Database UUID
                customerId: response.data.customerId,  // Display ID
              },
              customerId: response.data.customerId,    // Top-level for easy access
              executive: {
                id: loginCredintials.employeeId,
              },
              branch: loginCredintials.branch[0],
              accessories: [],
            };

            setSelectedBooking(customerData);
          } else {
            console.error("Error in response:", response);
          }
        } else {
          console.error("Error fetching customer:", data);
        }
      })
      .catch((error) => {
        console.error("Error fetching customer:", error);
      });
  }, [customerId, quotationModal, bookingModal, loginCredintials]);

  const createBooking = (bookingRegister, showMessage = false, skipApi = false) => {
    if (skipApi === true) {
      setSelectedBooking((prev) => ({ ...prev, ...bookingRegister }));
      return;
    }
    if (bookingRegister.id) {
      platformApi
        .put(`/api/booking/${bookingRegister.id}`, bookingRegister)
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setBookingId(response.data.bookingId);
              setSelectedBooking(response.data);
              getActivityByCustomer();

              // Show success message for update
              message.success("Booking updated successfully!", 2);

              showMessage && message.success("Booking saved successfully", 1);

              // Call success callback if provided
              if (typeof skipApi === "function") skipApi();
            } else {
              message.error(1);
            }
          } else {
            message.error(1);
          }
        })
        .catch((err) => {
          message.error(1);
          console.error("Error on booking : ", err);
        });
    } else {
      platformApi
        .post("/api/booking/create", bookingRegister)
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            let { response } = res.data;
            if (response.code === 200) {
              setSelectedBooking(response.data);

              // Show success message for new booking
              message.success("Booking created successfully!", 2);

              if (response.data.bookingStatus === "ACCEPTED")
                sendConfirmSMS(response.data);
              getActivityByCustomer();

              // Call success callback to close modal
              if (typeof skipApi === "function") skipApi();

            } else {
              message.error("Error in booking creation", 2);
            }
          } else {
            message.error("Error in booking creation", 2);
          }
        })
        .catch((err) => {
          console.error("Error on booking : ", err);
          message.error("Failed to create booking. Please try again.", 3);
        });
    }
  };

  const sendConfirmSMS = (data) => {
    const {
      bookingId,
      branch,
      executive: {
        profile: { employeeName },
      },
      authentication,
      customer: { name, contacts },
      vehicle: { modelName },
    } = data;
    const phone = contacts[0].phone;
    const smsdata = {
      pdflink:
        authentication.afterVerification || authentication.beforeVerification,
      cname: name,
      vname: modelName,
      bkid: bookingId,
      slex: employeeName,
      clink: "-",
      dlr: branch.name,
    };
    platformApi
      .post("/api/sendSms/bookingconfirm", {
        phone,
        smsdata,
      })
      .then((res) => {
        const { data } = res;
        if (data.code === 200) {
          message.success("Message sent successfully");
        } else if (data.code === 401) {
          message.error(data.message);
        } else {
          message.error("Unable to send SMS");
        }
      });
  };

  const openCreateQuotation = () => {
    setQuotationEditable(true);
    setQuotationModal(true);
    setView(false);
  };

  const openBookingModal = (type) => {
    setBookingType(type);
    //setting booking id
    platformApi.post("/api/idGenerate/booking").then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        setBookingId(response.data);
      } else {
        message.error("Couldn't fetch id");
      }
    });
    setBookingModal(true);
  };

  return (
    <div className="quotation-info">
      <Card style={{ height: "260px" }}>
        <Row type="flex" justify="space-between" gutter={[16, 16]}>
          <Col span={18}>
            <Row type="flex" justify="space-between" gutter={[16, 16]}>
              <Col span={24}>
                <Table
                  locale={{
                    emptyText: (
                      <Empty
                        imageStyle={{
                          height: 25,
                          fontSize: 30,
                        }}
                        description={
                          <Text disabled strong>
                            No Quotations Associated
                          </Text>
                        }
                      />
                    ),
                  }}
                  rowKey={(record) => record.id}
                  pagination={false}
                  size="small"
                  columns={column}
                  dataSource={dataSource}
                />
              </Col>
              <Col span={24}>
                <span
                  className="linkylink"
                  onClick={() => setAttachQuotationModal(true)}
                >
                  Attach Quotation
                </span>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <Row type="flex" gutter={[16, 16]} justify="space-between">
              {/* <Col span={24}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => openBookingModal("ConfirmBooking")}
                >
                  Confirm Booking
                </Button>
              </Col> */}
              <Col span={24}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => openBookingModal("AdvancedBooking")}
                >
                  Booking
                </Button>
              </Col>
              <Col span={24}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => openCreateQuotation()}
                >
                  Quotation
                </Button>
              </Col>
              <Col span={24}>
                <Button
                  style={{ width: "100%" }}
                  onClick={() => setActivityModal(true)}
                >
                  Walk-In
                </Button>
              </Col>
              <Row >
                <Col span={8} >
                  <Button onClick={() => { setCallModal(true) }} style={{ marginLeft: "50px" }}>
                    <Icon type="phone" />
                  </Button>
                </Col>
                {/* <Col span={8}>
                  <Button onClick={() => setMessageModal(true)}>
                    <Icon type="message" />
                  </Button>
                </Col>
                <Col span={8}>
                  <Button onClick={() => setWhatsAppMessageModal(true)}>
                    <WhatsAppOutlined />
                  </Button>
                </Col> */}

              </Row>
            </Row>
          </Col>
          {/* <Col>
          </Col> */}
        </Row>
      </Card>

      <WrappedMessageInterface
        visibility={messageModal}
        customerDetail={customerDetail}
        getCustomerInfo={getCustomerInfo}
        getActivityByCustomer={getActivityByCustomer}
        setVisibility={setMessageModal}
      />
      <WrappedWhatsAppInterface
        visibility={whatsAppMessageModal}
        customerDetail={customerDetail}
        getCustomerInfo={getCustomerInfo}
        getActivityByCustomer={getActivityByCustomer}
        setVisibility={setWhatsAppMessageModal}
      />
      <WrappedCallingInterface
        getActivityByCustomer={getActivityByCustomer}
        visibility={callModal}
        createQuotation={createQuotation}
        customerDetail={customerDetail}
        setVisibility={setCallModal}
        activityType={"Follow-Ups"}
        moduleid={moduleid}
      />
      <AttachQuotation
        visibility={attachQuotationModal}
        setVisibility={setAttachQuotationModal}
        onSave={linkQuotation}
        customerDetail={customerDetail}
      />
      <QuotationModal
        leadData={null}
        editable={quotationEditable}
        emitData={(quotation, onSuccess) => {
          // Call createQuotation and pass a callback to handle success
          createQuotation(quotation, (success, data) => {
            if (success) {
              // Close the modal
              setQuotationModal(false);
              setQuotationEditable(false);
              // Refresh the quotations list
              getCustomerInfo();
              getActivityByCustomer();
              // Call the onSuccess callback if provided
              if (onSuccess) {
                onSuccess(data);
              }
            }
          });
        }}
        setView={setView}
        view={view}
        cusData={customerDetail}
        data={quotationDetail}
        open={quotationModal}
        close={() => {
          setQuotationDetail(null);
          setQuotationEditable(false);
          setQuotationModal(false);
          setView(false);
        }}
        addData={async (quotation, callBack) => {
          let tmpQuotation = await getQuotation(quotation.id);
          tmpQuotation.pdfWithBrochure = quotation.pdfWithBrochure;
          tmpQuotation.pdfWithOutBrochure = quotation.pdfWithOutBrochure;
          if (callBack) callBack(tmpQuotation);
        }}
      />
      {bookingModal && <BookingRegisterModal
        id={bookingId}
        currentData={selectedBooking}
        // customerDetail={customerDetail}
        emitData={(data, showMessage, skipApi) => createBooking(data, showMessage, skipApi)}
        editable={true}
        mode={bookingType}
        open={bookingModal}
        clearBookingData={(data) => setSelectedBooking(data)}
        close={() => {
          setBookingId("");
          setBookingModal(false);
        }}
      />}

      <WrappedAddActivityModal
        visibility={activityModal}
        getActivityByCustomer={getActivityByCustomer}
        customerDetail={customerDetail}
        setVisibility={setActivityModal}
        quotations={dataSource}
      />
    </div>
  );
};

export default QuotationInfo;
